import React, { forwardRef, useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Icon } from "../Icon";
import { EqualHeightElement } from "../EqualHeight/EqualHeightElement";
import { useMediaQuery, mediaQueries } from "../hooks/useMediaQuery";

import { LinkListColumnContext } from "./LinkListColumn";

import styles from "./LinkList.scss";

const LinkListCategory = forwardRef(({ children, icon }, ref) => {
  const { columnId } = useContext(LinkListColumnContext);
  const isViewportM = useMediaQuery(mediaQueries.m);
  const [name, setName] = useState("category-row-0");

  useEffect(() => {
    if (isViewportM) {
      // viewport m breaks columns to pairs of 2 -> assign name per row
      setName(`category-row-${Math.floor(columnId / 2.0)}`);
    } else {
      setName("category-row-0");
    }
  }, [isViewportM]);

  return (
    <EqualHeightElement name={name} className={styles["no-equal-height-s"]}>
      <div ref={ref} className={styles.category}>
        {icon && (
          <span className={styles["category-icon-wrap"]}>
            <span className={styles["category-icon"]}>
              <Icon icon={icon} size={Icon.Size.parent} />
            </span>
          </span>
        )}
        <span className={styles["category-text"]}>{children}</span>
      </div>
    </EqualHeightElement>
  );
});

LinkListCategory.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  icon: PropTypes.elementType,
};

LinkListCategory.defaultProps = {
  icon: null,
};

LinkListCategory.displayName = "LinkList.Category";

export default LinkListCategory;
